// extracted by mini-css-extract-plugin
export var externalLink = "_9b-0";
export var internalLinkLabel = "_9b-1";